import { useCallback, useMemo } from "react";

import { RichText, RichTextViewer } from "simplydo/react/richtext";
import { presets } from "simplydo/react/richtext/presets/presets";

const SimpleOptions = presets.simple.options.map((option) => option.name);

// Ideas are a bit poorly optimised when it comes to updates, by wrapping the handlers a bit differently for fields we save a decent amount of unnecessary updates
const RichTextField = ({
  ideaId,
  field,
  fieldValue = "",
  updateIdea,
  isEditing,
}) => {
  const onChange = useCallback(
    (html) => updateIdea(html, ["templated", field.id]),
    [updateIdea, field.id],
  );

  // Determine which extensions and menu items to use based on field settings
  // We need to separate extensions and menu, because e.g. video requires iframe extension, but we might not want to show iframe in the menu
  const [presetExtensions, presetMenu] = useMemo(() => {
    const extensions = [...SimpleOptions];
    const menu = [...SimpleOptions];
    if (field.allowFileUploads !== false) {
      extensions.push("file");
      menu.push("file");
    }
    if (field.allowImageUploads !== false) {
      extensions.push("image");
      menu.push("image");
    }
    if (field.allowVideoUploads !== false) {
      extensions.push("video");
      extensions.push("iframe");
      menu.push("video");
    }
    if (field.allowIframes !== false) {
      extensions.push("iframe");
      menu.push("iframe");
    }
    return [extensions, menu];
  }, [field]);

  if (!isEditing) return <RichTextViewer content={fieldValue} />;
  return (
    <RichText
      preset="custom"
      customPresetExtensions={presetExtensions}
      customPresetMenu={presetMenu}
      stickyMenu={true}
      stickyMenuOffset={140}
      emptyReturnValue={null}
      historyEnabled={false}
      onChange={onChange}
      forType="idea"
      forId={ideaId}
      value={fieldValue}
    />
  );
};

export default RichTextField;
